import usabilidadeDoSistemaCoordenador from "../Pages/AdminPage/Usabilidade/UsabilidadeDoSistemaCoordenadorPage.vue";

export default [
  {
    path: "/usabilidade/usabilidadeDoSistemaCoordenador",
    name: "usabilidade.usabilidadeDoSistemaCoordenador",
    component: usabilidadeDoSistemaCoordenador,
  },
];
